<template>
  <a :class="selectionClasses" @click.prevent="optionClickHandler">
    <div class="wizard__selection__inside">
      <div class="wizard__selection__icon">
        <slot></slot>
      </div>
      <label class="wizard__selection__label" v-html="label"></label>
    </div>
  </a>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true
      },

      value: {
        type: String,
        required: true
      },

      onResponse: {
        type: Function
      },

      name: {
        type: String
      }
    },

    data: () => ({

    }),

    computed: {
      selectionClasses() {
        return {
          'wizard__selection': true
        }
      }
    },


    mounted() {

    },

    methods: {
      optionClickHandler() {
        if (! this.onResponse) return;

        this.onResponse({
          data: {
            [this.name]: this.value
          },
          response: this.value
        });
      }
    }
  };
</script>
